import React, { Component, Suspense } from 'react';
import {Router, Route,Switch} from 'react-router-dom'
import ProductsList from './components/productsList.jsx'
import ProductsItem from './components/productsItem.jsx';
import CartList from './components/cartList';
import CheckoutList from './components/checkout';
import ProductsWishlist from './components/ProductsWishlist'
import {createBrowserHistory } from 'history'
import Redirect from "./components/redirect";
import ProductsComparelist from "./components/ProductsComparelist";
import JoomlaMenu from "./components/topmenu";
import SubMenu from "./components/CustomMenu/SubMenu";
import WrapperProductList from "./components/CustomMenu/list/WrapperProductList";
import PromoProducts from "./components/CustomMenu/list/PromoProducts";
import CategoriesList from "./components/CategoriesList";
import './i18n';

export default class App extends Component{

    constructor(props){
        super(props);
        this.history = createBrowserHistory();
        // console.log("ge33");
    }


    render(){
        return (
            <Router history={this.history}>
                <Switch>
                    <Suspense fallback="loading">

                        <Route
                            path="/products"
                            render={({ match: { url } }) => (
                                <>
                                    <Route path={`${url}/`} component={JoomlaMenu}  />
                                    <Route path={`${url}/:lang?/:cat?/`} component={ProductsList} exact={true}/>
                                    <Route exact={true} path={`${url}/:lang?/wishlist/list/`} component={ProductsWishlist} />
                                    <Route exact={true} path={`${url}/:lang?/compare/list/`} component={ProductsComparelist} />
                                    <Route exact={true} path={`${url}/:lang?/cart/list`} component={CartList} />
                                    <Route exact={true} path={`${url}/:lang?/cart/checkout`} component={CheckoutList} />
                                    <Route exact={true} path={`${url}/:lang?/cat/:catId`} component={SubMenu} />
                                    <Route exact={true} path={`${url}/:lang?/promo/actions`} component={PromoProducts} />
                                    <Route exact={true} path={`${url}/:lang?/custom/:alias/:categoryFilter?`} component={WrapperProductList} />
                                    <Route exact={true} path={`${url}/:lang?/:category?/item/:id?/`} component={ProductsItem} />
                                    <Route exact={true} path={`${url}/:lang?/:category?/list`} component={CategoriesList} />
                                </>
                            )}
                            >
                        </Route>
                        <Route exact={true} path={'/product/redirect/external/:link?/'} component={Redirect} />

                    </Suspense>
                </Switch>
            </Router>
        );
    }

}
